<div class="modal-overlay" *ngIf="showAcceptOffer || showRetractOffer">
  <div id="retract-offer-modal" class="modal-wrapper" *ngIf="showRetractOffer">
    <div class="d-flex flex-grow-0 flex-column container">
      <button class="close-button btn" (click)="closeRetractModal()">
        <mat-icon>close</mat-icon>
      </button>
      <span class="title">{{'offer.retractOfferQuestion'|translate:{
        offerNumber: selectedOffer.offerId.slice(0, 8)
      } }}</span>
      <div class="body-text-wrapper">
        <img class="mr-1" src="assets/svg-icons/circle-actions-alert-info.svg" alt="">
        <span
          class="body-text">{{'offer.retractOfferText'|translate: {
          offerNumber: selectedOffer.offerId.slice(0, 8)
        } }}</span>
      </div>

      <div class="d-flex button-container justify-content-between">
        <button class="blue-border" (click)="closeRetractModal()">{{'offer.dontRetractOffer'|translate}}</button>
        <button class="retract-button"
                (click)="retractOffer()">{{'offer.retractOfferLegal'|translate}}</button>
      </div>
    </div>
  </div>

  <div id="accept-offer-modal" class="modal-wrapper" *ngIf="showAcceptOffer">
    <div class="d-flex flex-grow-0 flex-column container">
      <button class="close-button btn" (click)="closeModal()">
        <mat-icon>close</mat-icon>
      </button>
      <span class="title">{{'offer.acceptOfferQuestion'|translate}}</span>
      <div class="body-text-wrapper">
        <img class="mr-1" src="assets/svg-icons/circle-actions-alert-info.svg" alt="">
        <span class="body-text">{{'offer.acceptOfferText'|translate: {
          offerNumber: selectedOffer.offerId.slice(0, 8),
          member: selectedOffer.creator.firstName + " " + selectedOffer.creator.lastName,
          company: selectedOffer.creator.company.name
        } }}</span>
      </div>
      <div class="leading-offer-section" *ngIf="selectedOffer?.isLeading">
        <hr>
        <span>
          {{ 'offer.acceptLeadingOfferText' | translate }}
        </span>

        <div class="d-flex flex-column gap-4">
<br>
          <div class="d-flex align-items-center" inert>
            <mat-slide-toggle [checked]="true" style="
              --mdc-switch-selected-track-color: #82a2bb !important;
              --mdc-switch-selected-pressed-track-color: #82a2bb !important;
              --mdc-switch-selected-hover-track-color: #82a2bb !important;
              --mdc-switch-selected-focus-track-color: #82a2bb !important;">
            </mat-slide-toggle>
            <span>{{ 'offer.acceptOfferButtonCompany' | translate:{companyName: selectedOffer.creator.company.name} }}</span>
          </div>

          <div class="d-flex align-items-center">
            <mat-slide-toggle [(ngModel)]="includeCoverage"></mat-slide-toggle>
            <span>{{ 'offer.acceptOfferButtonCoverage' | translate }}</span>
          </div>

          <div class="d-flex align-items-center">
            <mat-slide-toggle [(ngModel)]="includeClausesAndConditions"></mat-slide-toggle>
            <span>{{ 'offer.acceptOfferButtonClauses' | translate }}</span>
          </div>

          <div class="d-flex align-items-center">
            <mat-slide-toggle [(ngModel)]="includePremium"></mat-slide-toggle>
            <span>{{ 'offer.acceptOfferButtonPremium' | translate }}</span>
          </div>
          <br>

        </div>
      </div>

      <div class="d-flex button-container justify-content-between">
        <button class="blue-border cancel" (click)="closeModal()">{{'cancel'|translate}}</button>
        <button class="blue-content"
                (click)="acceptOffer()">{{'offer.acceptOfferLegal'|translate}}</button>
      </div>
    </div>
  </div>
</div>
